export default [
  //首页
  {
    path: "/h5/index/active/activeDetail",
    name: "/h5/index/active/activeDetail",
    component: () => import("../views/h5/index/active/activeDetail"),
    meta: {
      name: "activeDetail",
    },
  },
  {
    path: "/h5/index/active/activePay",
    name: "/h5/index/active/activePay",
    component: () => import("../views/h5/index/active/activePay"),
    meta: {
      name: "activePay",
      hideShare: true,
    },
  },
  {
    path: "/h5/index/artHeaderLine",
    name: "/h5/index/artHeaderLine",
    component: () => import("../views/h5/index/artHeaderLine"),
    meta: {
      name: "artHeaderLine",
      hideShare: true,
    },
  },
  {
    path: "/h5/index/vip/vip",
    name: "/h5/index/vip/vip",
    component: () => import("../views/h5/index/vip/vip"),
    meta: {
      name: "vip",
    },
  },
  {
    path: "/h5/index/vip/svipDetail",
    name: "/h5/index/vip/svipDetail",
    component: () => import("../views/h5/index/vip/svipDetail"),
    meta: {
      name: "svipDetail",
    },
  },
  {
    path: "/h5/index/vip/bind",
    name: "/h5/index/vip/bind",
    component: () => import("../views/h5/index/vip/bind"),
    meta: {
        hideShare: true,
      },
  },
  //我的
  {
    path: "/h5/mine/promote/promotion",
    name: "/h5/mine/promote/promotion",
    component: () => import("../views/h5/mine/promote/promotion"),
    meta: {
      name: "promotion",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/promote/promoteRule",
    name: "/h5/mine/promote/promoteRule",
    component: () => import("../views/h5/mine/promote/promoteRule"),
    meta: {
      name: "promoteRule",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/promote/promoteStatus",
    name: "/h5/mine/promote/promoteStatus",
    component: () => import("../views/h5/mine/promote/promoteStatus"),
    meta: {
      name: "promoteStatus",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/promote/promote",
    name: "/h5/mine/promote/promote",
    component: () => import("../views/h5/mine/promote/promote"),
    meta: {
      name: "promote",
    },
  },
  {
    path: "/h5/mine/promote/promoters",
    name: "/h5/mine/promote/promoters",
    component: () => import("../views/h5/mine/promote/promoters"),
    meta: {
      name: "promoters",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/promote/customer",
    name: "/h5/mine/promote/customer",
    component: () => import("../views/h5/mine/promote/customer"),
    meta: {
      name: "customer",
      hideShare: true,
    },
  },

  {
    path: "/h5/mine/promote/bonus",
    name: "/h5/mine/promote/bonus",
    component: () => import("../views/h5/mine/promote/bonus"),
    meta: {
      name: "bonus",
      hideShare: true,
    },
  },
  // 推广员邀请
  {
    path: "/h5/mine/promote/extensionInvitation",
    name: "/h5/mine/promote/extensionInvitation",
    component: () => import("../views/h5/mine/promote/extensionInvitation"),
    meta: {
      name: "extensionInvitation",
      hideShare: true,
    },
  },

  // 银行卡
  {
    path: "/h5/mine/bankCard/bankCard",
    name: "/h5/mine/bankCard/bankCard",
    component: () => import("../views/h5/mine/bankCard/bankCard"),
    meta: {
      name: "bankCard",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/bankCard/bindBankCard",
    name: "/h5/mine/bankCard/bindBankCard",
    component: () => import("../views/h5/mine/bankCard/bindBankCard"),
    meta: {
      name: "bindBankCard",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/order/orderDetail",
    name: "/h5/mine/order/orderDetail",
    component: () => import("../views/h5/mine/order/orderDetail"),
    meta: {
      name: "orderDetail",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/bankCard/createWithdrawal",
    name: "/h5/mine/bankCard/createWithdrawal",
    component: () => import("../views/h5/mine/bankCard/createWithdrawal"),
    meta: {
      name: "createWithdrawal",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/bankCard/withdrawalRecord",
    name: "/h5/mine/bankCard/withdrawalRecord",
    component: () => import("../views/h5/mine/bankCard/withdrawalRecord"),
    meta: {
      name: "withdrawalRecord",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/bankCard/chooseBank",
    name: "/h5/mine/bankCard/chooseBank",
    component: () => import("../views/h5/mine/bankCard/chooseBank.vue"),
    meta: {
      name: "chooseBank",
      hideShare: true,
    },
  },
  {
    path: "/h5/mine/bankCard/verify",
    name: "/h5/mine/bankCard/verify",
    component: () => import("../views/h5/mine/bankCard/verify.vue"),
    meta: {
        hideShare: true,
      },
  },
  {
    path: "/h5/mine/recommend/recommend",
    name: "/h5/mine/recommend/recommend",
    component: () => import("../views/h5/mine/recommend/recommend.vue"),
  },

  //登录
  {
    path: "/login/bindInfo",
    name: "/login/bindInfo",
    component: () => import("../views/login/bindInfo.vue"),
    meta: {
      hideShare: true,
    },
  },
  {
    path: "/login/login",
    name: "/login/login",
    component: () => import("../views/login/login.vue"),
    meta: {
      hideShare: true,
    },
  },
  {
    path: "/login/loginBoard",
    name: "/login/loginBoard",
    component: () => import("../views/login/loginBoard.vue"),
    meta: {
      hideShare: true,
    },
  },
  {
    path: "/h5/common/areaCode",
    name: "/h5/common/areaCode",
    component: () => import("../views/h5/common/areaCode.vue"),
    meta: {
      name: "areaCode",
      hideShare: true,
    },
  },
  {
    path: "/h5/common/paySuccess",
    name: "/h5/common/paySuccess",
    component: () => import("../views//h5/common/paySuccess.vue"),
    meta: {
      name: "paySuccess",
      hideShare: true,
    },
  },

  //h5
  //课程

  {
    path: "/h5/course/artHome/artHome",
    name: "/h5/course/artHome/artHome",
    component: () => import("../views/h5/course/artHome/artHome.vue"),
    meta: {
      name: "artHome",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/artHome/artHomeFans",
    name: "/h5/course/artHome/artHomeFans",
    component: () => import("../views/h5/course/artHome/artHomeFans.vue"),
    meta: {
      name: "fans",
    },
  },
  {
    path: "/h5/course/artHome/liveList",
    name: "/h5/course/artHome/liveList",
    component: () => import("../views/h5/course/artHome/liveList.vue"),
    meta: {
      name: "liveList",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/artHome/dynamicDetail",
    name: "/h5/course/artHome/dynamicDetail",
    component: () => import("../views/h5/course/artHome/dynamicDetail.vue"),
    meta: {
      name: "dynamicDetail",
    },
  },
  {
    path: "/h5/course/artHome/workDetail",
    name: "/h5/course/artHome/workDetail",
    component: () => import("../views/h5/course/artHome/workDetail.vue"),
    meta: {
      name: "workDetail",
    },
  },
  {
    path: "/h5/course/artHome/workEvaluation",
    name: "/h5/course/artHome/workEvaluation",
    component: () => import("../views/h5/course/artHome/workEvaluation.vue"),
    meta: {
      name: "workEvaluation",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/artHome/chat",
    name: "/h5/course/artHome/chat",
    component: () => import("../views/h5/course/artHome/chat.vue"),
    meta: {
      name: "chat",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/artHome/live",
    name: "/h5/course/artHome/live",
    component: () => import("../views/h5/course/artHome/live.vue"),
    meta: {
      name: "teacherLive",
      hideShare: true,

    },
  },
  {
    path: "/h5/course/live",
    name: "/h5/course/live",
    component: () => import("../views/h5/course/live.vue"),
    meta: {
      name: "live",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/courseType",
    name: "/h5/course/courseType",
    component: () => import("../views/h5/course/courseType.vue"),
    meta: {
      name: "courseType",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/invite",
    name: "/h5/course/invite",
    component: () => import("../views/h5/course/invite.vue"),
  },
  {
    path: "/h5/course/courseDetail",
    name: "/h5/course/courseDetail",
    component: () => import("../views/h5/course/courseDetail.vue"),
    meta: {
      name: "courseDetail",
    },
  },
  {
    path: "/h5/course/coursePackage",
    name: "/h5/course/coursePackage",
    component: () => import("../views/h5/course/coursePackage.vue"),
    meta: {
      name: "coursePackage",
    },
  },
  {
    path: "/h5/course/groupDetail",
    name: "/h5/course/groupDetail",
    component: () => import("../views/h5/course/groupDetail.vue"),
    meta: {
      name: "groupDetail",
    },
  },
  {
    path: "/h5/course/coursePlay",
    name: "/h5/course/coursePlay",
    component: () => import("../views/h5/course/coursePlay.vue"),
    meta: {
      name: "coursePlay",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/group",
    name: "/h5/course/group",
    component: () => import("../views/h5/course/group.vue"),
    meta: {
      name: "group",
      hideShare: true,
    },
  },
  {
    path: "/h5/course/courseConverge",
    name: "/h5/course/courseConverge",
    component: () => import("../views/h5/course/courseConverge.vue"),
    meta: {
      name: "courseConverge",
    },
  },
  {
    path: "/h5/course/classIntroduction",
    name: "/h5/course/classIntroduction",
    component: () => import("../views/h5/course/classIntroduction.vue"),
    meta:{
      hideShare: true,
    }
  },
  {
    path: "/h5/common/order",
    name: "/h5/common/order",
    component: () => import("../views/h5/common/order.vue"),
    meta: {
      name: "order",
      hideShare: true,
    },
  },
  // 社区
  {
    path: "/h5/community/topic",
    name: "/h5/community/topic",
    component: () => import("../views/h5/community/topic"),
    meta: {
      name: "topic",
    },
  },
  {
    path: "/h5/community/studentPage",
    name: "/h5/community/studentPage",
    component: () => import("../views/h5/community/studentPage"),
    meta: {
      name: "studentPage",
    },
  },
  {
    path: "/h5/community/subscribesList",
    name: "/h5/community/subscribesList",
    component: () => import("../views/h5/community/subscribesList"),
    meta: {
      name: "subscribesList",
      hideShare: true,
    },
  },
  {
    path: "/h5/community/allDiscussion",
    name: "/h5/community/allDiscussion",
    component: () => import("../views/h5/community/allDiscussion"),
    meta:{
      hideShare: true,
    }
  },
];
